import React, { useState } from "react";
import { Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";

import CardHeader from "../Layout/CardHeader";
import SuperInsightsModal from "../Ia/SuperInsightsModal";
import Meta from '../Layout/Meta';


import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Exemplo de dados (em formato string JSON)
/*let dadosComponente_ = '[{"nome":"Loja A","lat":-23.55,"lng":-46.63,"status":"adequado"},{"nome":"Loja B","lat":-22.90,"lng":-47.06,"status":"alerta"},{"nome":"Loja C","lat":-23.19,"lng":-45.88,"status":"ruptura"}]';
let conteudoOpcoes_  = '[-23.55, -46.63]';

function corrigirJson(str) {
  // Abordagem simples usando regex para colocar aspas nas chaves
  // Pode precisar de ajustes dependendo das variações do conteúdo
  const corrigido = str.replace(/([{,]\s*)(\w+)(\s*:)/g, '$1"$2"$3');
  return JSON.parse(corrigido);
}  

const dadosComponente = corrigirJson(dadosComponente_);
const conteudoOpcoes = corrigirJson(conteudoOpcoes_);
*/

// Função para determinar a cor do marcador
const getMarkerColor = (status) => {
  if (status === "adequado") return "green";
  if (status === "alerta") return "orange";
  if (status === "ruptura") return "red";
  return "#777";
};

// Cria um ícone customizado para cada marcador
const getMarkerIcon = (status) => {
  return L.divIcon({
    html: `<div style="background-color:${getMarkerColor(status)}; width:12px; height:12px; border-radius:50%; border:1px solid #fff;"></div>`,
    iconSize: [12, 12],
    className: "",
  });
};

// Componente auxiliar que força o Leaflet a recalcular o tamanho do mapa
function FixLeafletResize() {
  const map = useMap();
  React.useEffect(() => {
    map.invalidateSize();
  }, [map]);
  return null;
}


const MapChart = ({ item }) => {

  // Verificação segura do item e seus valores
  const safeItem = item || {};

  // Destructuring com fallbacks seguros
  const {
    Sigla,
    Descricao_Dashboard_Componente: titulo = "-",
    dadosComponente = [],   
    Valor_Meta = {},
    Texto_Info = "-",
    Texto_BizAI = "",
    ESG_Info = "-",
    Codigo_Transacao_Link = "",
    Titulo_Transacao_Link = "",
    opcoesComponente,
  } = safeItem;

  // Controle do Modal
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => setIsPopupOpen(!isPopupOpen);;
 const slugId = Sigla.trim().replace(/\s+/g, "-");
  
  // Define o centro do mapa (São Paulo) e o nível de zoom
  const centerMap = [-23.55, -46.63];
  const zoom = 6;

  return (
      <>
    <Card className="w-100 h-100">
      <CardBody className="w-100 h-100 d-flex flex-column cardbody-dash">
         <CardHeader
            titulo={titulo}
            Texto_Info={Texto_Info}
            ESG_Info={ESG_Info}
            togglePopup={togglePopup}
            slugId={slugId}
            textoIA={Texto_BizAI}
            Codigo_Transacao_Link={Codigo_Transacao_Link}
            Titulo_Transacao_Link={Titulo_Transacao_Link}
        />

          {/* Metas e Valores */}       
          <Meta Valor_Meta={Valor_Meta} />

        {/* Container do mapa */}
         <div style={{ marginTop: "20px", width: "100%", height: "100%" }}>
          <MapContainer
            center={centerMap}
            zoom={zoom}
            style={{ width: "100%", height: "100%" }}
          >
            {/* Ajusta o tamanho se o componente estiver dentro de um accordion */}
            <FixLeafletResize />

            {/* Camada de tiles do OpenStreetMap */}
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {/* Marcadores */}
            {dadosComponente.map((loja, index) => (
              <Marker
                key={index}
                position={[loja.lat, loja.lng]}
                icon={getMarkerIcon(loja.status)}
              >
                <Popup>
                  <strong>{loja.nome}</strong>
                  <br />
                  Status: {loja.status}
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>

        {/* Legenda (tudo em uma linha) */}
        <div style={{ display: "flex", alignItems: "center", marginTop: 10 }}>
          {/* Adequado */}
          <div style={{ display: "flex", alignItems: "center", marginRight: 20 }}>
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                backgroundColor: "green",
                borderRadius: "50%",
                marginRight: 5,
              }}
            />
            <span>Estoque em Nível Adequado</span>
          </div>

          {/* Alerta */}
          <div style={{ display: "flex", alignItems: "center", marginRight: 20 }}>
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                backgroundColor: "orange",
                borderRadius: "50%",
                marginRight: 5,
              }}
            />
            <span>Alerta de Ruptura</span>
          </div>

          {/* Ruptura */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                backgroundColor: "red",
                borderRadius: "50%",
                marginRight: 5,
              }}
            />
            <span>Estoque em Ruptura</span>
          </div>
        </div>
      </CardBody>
    </Card>

      {/* Modal de Insights */}
      <SuperInsightsModal
        isOpen={isPopupOpen}
        toggle={togglePopup}
        textoIA={Texto_BizAI} // Passamos somente o texto da pergunta
      />
    </>
  );
};

export default MapChart;
